import { formatDate } from '../../lib/format.js';

const CONFIG = {
  draft: {
    label: 'Brouillon',
    className: 'bg-slate-100 text-slate-600 ring-slate-200',
  },
  validated: {
    label: 'Cristallisé',
    className: 'bg-green-100 text-green-700 ring-green-200',
  },
};

export default function StatusBadge({ status, validatedAt, validatedBy }) {
  const cfg = CONFIG[status] ?? CONFIG.draft;

  return (
    <div className="flex flex-col items-end gap-0.5">
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${cfg.className}`}
      >
        {cfg.label}
      </span>
      {status === 'validated' && validatedAt && (
        <span className="text-[10px] text-slate-400">
          {formatDate(validatedAt)}
          {validatedBy ? ` · ${validatedBy}` : ''}
        </span>
      )}
    </div>
  );
}
